import { Modal, useModals } from 'almanac-ui/Modal'
import { ModalProps } from 'almanac-ui/Modal/Types'
import { useId } from '@react-aria/utils'
import { useLinkedAccountsController } from 'screens/BrandKit/LinkedAccountsDrawer/useLinkedAccountsController'
import { Panel } from 'screens/BrandKit/LinkedAccountsDrawer/consts'
import { DefaultProps } from 'screens/BrandKit/LinkedAccountsDrawer/Types'

export type LinkedAccountsModalProps = DefaultProps & {
  initialPanel?: Panel
} & Partial<Omit<ModalProps, 'children'>>

export const LinkedAccountsModal = ({ brandKitId, initialPanel, ...modalProps }: LinkedAccountsModalProps) => {
  const { closeModal } = useModals()
  const titleId = useId()

  const { heading, handleBack, panels } = useLinkedAccountsController({
    brandKitId,
    initialPanel,
    onExit: closeModal,
  })

  return (
    <Modal.Root size="sm" aria-labelledby={titleId} onPressOutside={closeModal} {...modalProps}>
      <Modal.Header title={heading} id={titleId} onBack={handleBack} onClose={closeModal} />
      <Modal.Content>{panels}</Modal.Content>
    </Modal.Root>
  )
}
